// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/app-" + chunkId + "." + {"3042":"c04d977e","5041":"02da20d1","7087":"9cac6a25","9725":"81a5f806"}[chunkId] + ".chunk.css";
};